(() => {
    const mobileNavigationToggle = document.querySelector(
        '[data-mobile-navigation-toggle]',
    );

    if (mobileNavigationToggle) {
        mobileNavigationToggle.addEventListener('click', () => {
            document.body.classList.toggle('navigation-open');
        });
    }
})();
